import { Box, Stack, Typography } from "@mui/joy";
import LineChart from "./LineChart";
import { TestResultType } from "api/dashboardApi";
import { selfCheckData, SelfCheckIdType } from "data/selfCheckData";
import CustomCard from "components/common/CustomCard";

interface TestResultProps extends TestResultType {
  isSelfCheckVertical?: boolean;
}

export default function TestResult({
  anxiety,
  depression,
  stress,
  burnout,
}: TestResultProps) {
  function getRangeLabelById(id: SelfCheckIdType, score: number) {
    const resultRangeData = selfCheckData[id].result;
    return resultRangeData.find(
      ({ range }) => score >= range[0] && score <= range[1]
    )?.label;
  }

  function getMaxScoreById(id: SelfCheckIdType) {
    const resultRangeData = selfCheckData[id].result;
    return resultRangeData[resultRangeData.length - 1].range[1];
  }

  function TestResultById({
    id,
    title,
    scoreList,
  }: {
    id: SelfCheckIdType;
    title: string;
    scoreList: number[];
  }) {
    return (
      <CustomCard sx={{ flex: 1 }}>
        <Stack
          direction="row"
          flexGrow={1}
          justifyContent={"space-between"}
          sx={{
            p: 2,
          }}
        >
          <Stack spacing={2}>
            <Typography
              level="body-xs"
              fontWeight="lg"
              textColor="text.secondary"
              whiteSpace={"nowrap"}
            >
              {title}
            </Typography>
            <Stack spacing={0}>
              <Typography
                level="title-md"
                fontWeight={"xl"}
                textColor="text.secondary"
                whiteSpace={"nowrap"}
              >
                {scoreList && scoreList.length > 0
                  ? `${scoreList[scoreList.length - 1]}점`
                  : "-"}
                {scoreList && scoreList.length > 0 && (
                  <Typography
                    level="body-xs"
                    fontWeight={"xl"}
                    textColor="text.secondary"
                    whiteSpace={"nowrap"}
                    sx={{ opacity: 0.5 }}
                  >
                    {` /${getMaxScoreById(id)}점`}
                  </Typography>
                )}
              </Typography>
              <Typography
                level="body-xs"
                fontWeight={"md"}
                textColor={
                  scoreList && scoreList.length > 1
                    ? scoreList[scoreList.length - 1] -
                        scoreList[scoreList.length - 2] >
                      0
                      ? "danger.500"
                      : "primary.solidBg"
                    : "text.secondary"
                }
                whiteSpace={"nowrap"}
              >
                {!scoreList || scoreList.length === 0
                  ? "검사 결과가 없어요."
                  : scoreList.length === 1
                  ? "2주 뒤 검사 후 그래프가 표시돼요."
                  : `${
                      scoreList[scoreList.length - 1] -
                        scoreList[scoreList.length - 2] <
                      0
                        ? "▼"
                        : "▲"
                    } ${Math.abs(
                      scoreList[scoreList.length - 1] -
                        scoreList[scoreList.length - 2]
                    )}점`}
              </Typography>
            </Stack>
          </Stack>
          {scoreList && scoreList.length > 1 && (
            <div className="w-[100px] h-[100px] relative">
              <LineChart data={scoreList} />
            </div>
          )}
        </Stack>
      </CustomCard>
    );
  }

  const data: { id: SelfCheckIdType; title: string; scoreList: number[] }[] = [
    { id: "anxiety", title: "불안", scoreList: anxiety?.scoreList || [] },
    {
      id: "depression",
      title: "우울",
      scoreList: depression?.scoreList || [],
    },
    { id: "stress", title: "스트레스", scoreList: stress?.scoreList || [] },
    // { id: "burnout", title: "번아웃", scoreList: burnout?.scoreList || [] },
  ];

  return (
    <Box
      className="w-full"
      sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
    >
      {data.map(({ id, title, scoreList }, index) => (
        <TestResultById
          key={`testResult_${id}`}
          id={id}
          title={title}
          scoreList={scoreList}
        />
      ))}
      {/* {[data.slice(0, 2), data.slice(2)].map((line, index) => (
        <Box
          key={`testResult_line_${index}`}
          className="w-full"
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
          }}
        >
          {line.map(({ id, title, scoreList }) => (
            <TestResultById
              key={`testResult_${id}`}
              id={id}
              title={title}
              scoreList={scoreList}
            />
          ))}
        </Box>
      ))} */}
    </Box>
  );
}
